import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// ============================================================
// 课程列表页逻辑
// ============================================================
import { intlMixin } from '@/i18n/intl-i18n';
import CourseCard from "../components/CourseCard.vue";
import CategoryFilter from "../components/CategoryFilter.vue";
import IntlBreadcrumb from "../components/IntlBreadcrumb.vue";
import IntlPagination from "../components/IntlPagination.vue";
import { getCourseList, getCourseCategories } from '@/api/international';
export default {
  name: 'IntlCourses',
  mixins: [intlMixin],
  components: {
    CourseCard: CourseCard,
    CategoryFilter: CategoryFilter,
    IntlBreadcrumb: IntlBreadcrumb,
    IntlPagination: IntlPagination
  },
  data: function data() {
    return {
      courseList: [],
      courseCats: [],
      activeCat: 'all',
      keyword: '',
      pageNum: 1,
      pageSize: 12,
      total: 0
    };
  },
  watch: {
    '$intlLang': function $intlLang() {
      this.loadList();
    }
  },
  mounted: function mounted() {
    this.loadCategories();
    this.loadList();
  },
  methods: {
    loadCategories: function () {
      var _loadCategories = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return getCourseCategories();
            case 1:
              res = _context.sent;
              if (res.data.code === 200) this.courseCats = res.data.data || [];
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error('loadCategories', _t);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2]]);
      }));
      function loadCategories() {
        return _loadCategories.apply(this, arguments);
      }
      return loadCategories;
    }(),
    loadList: function () {
      var _loadList = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, res, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              params = {
                pageNum: this.pageNum,
                pageSize: this.pageSize
              };
              if (this.activeCat !== 'all') params.category = this.activeCat;
              if (this.keyword) params.keyword = this.keyword;
              _context2.next = 1;
              return getCourseList(params);
            case 1:
              res = _context2.sent;
              if (res.data.code === 200) {
                this.courseList = res.data.rows || [];
                this.total = res.data.total || 0;
              }
              _context2.next = 3;
              break;
            case 2:
              _context2.prev = 2;
              _t2 = _context2["catch"](0);
              console.error('loadList', _t2);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function loadList() {
        return _loadList.apply(this, arguments);
      }
      return loadList;
    }(),
    onCatChange: function onCatChange(cat) {
      this.activeCat = cat;
      this.pageNum = 1;
      this.loadList();
    },
    onSearch: function onSearch() {
      this.pageNum = 1;
      this.loadList();
    },
    changePagination: function changePagination(_ref) {
      var page = _ref.page,
        size = _ref.size;
      this.pageNum = page;
      this.pageSize = size;
      this.loadList();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    goDetail: function goDetail(course) {
      this.$router.push({
        path: '/international/courseDetail',
        query: {
          id: course.id
        }
      });
    }
  }
};